import IncidentSection3 from './IncidentSection3';

export default IncidentSection3;
